<template>
    <v-dialog v-model="dialog">
        <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
                <v-icon>{{icons.plus}}</v-icon>
                Open
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Trackable Link
            </v-card-title>
            <v-card-text>
                <v-text-field :value="link" readonly />
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="Close()">
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "TrackableLink",
    components: {},
    data() {
      return {
        dialog: false,
        link: undefined
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    mounted(){
      this.link=window.location.href+'?cd='+(Math.random()*198492378)
    },
    methods: {
      ...mapActions(['get', 'post']),
      Close() {
        this.dialog = false
      }
    }
  }
</script>

<style scoped>

</style>